export const API_BASE = {
  localhost: '/profiles/outside/REST',
  sandbox: 'https://tomcat-qa-public.bostonglobe.com/profiles/outside/REST',
  prod: 'https://api.bostonglobe.com/profiles/outside/REST',
};
export const SUBDOMAIN = {
  localhost: 'arc-sandbox',
  sandbox: 'arc-sandbox',
  prod: 'www',
};
export const CONTACT = 'https://customerservice.globe.com/hc/en-us';
export const SUBSCRIBE_URL = 'https://subscribe.bostonglobe.com';
export const ONE_CLICK_REPURCHASE = 'https://manage.bostonglobe.com/cs/mc/oclogin.aspx';
export const MEMBER_CENTER = 'https://manage.bostonglobe.com/cs/mc/login.aspx';
export const ARCHIVE_URL = 'https://www.tkqlhce.com/click-8819575-11570746?url=' + encodeURIComponent('https://bostonglobe.newspapers.com/?xid=1880&tpa=');



// WEBPACK FOOTER //
// ./src/constants/constants-urls.js